/* eslint-disable dot-notation */
/* eslint-disable no-plusplus */
/* eslint-disable no-useless-escape */
/* eslint-disable max-len */
// @flow
/* eslint-disable react/no-access-state-in-setstate */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/no-unused-state */
/* eslint-disable react/no-danger */

import * as React from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import _ from 'lodash';

import { COLLECTIONS } from 'client/constants';
import { sentEmailInfo, addVotedEmailInfo } from 'client/actions';
import { Embed } from 'client/components/common/Embed';
// import { analytics } from 'common/utils/ga';

import * as css from './Final.scss';

type Props = {|
	className?: string,
	checklistInfo: ChecklistsItem,
	sentEmailInfo: typeof sentEmailInfo,
	addVotedEmailInfo: typeof addVotedEmailInfo,
	emailData: any,
|};

type State = {|
	form: {
		generalEmail: string,
		checkbox: boolean,
	},
	errors: {
		emailError: string,
		checkboxError: string,
	},
	emailSent: boolean,
|};

class EmailForm extends React.PureComponent<Props, State> {
	static defaultProps = {
		className: '',
	};

	state = {
		form: {
			generalEmail: '',
			checkbox: false,
		},
		errors: {
			emailError: '',
			checkboxError: '',
		},
		emailSent: false,
	};

	componentDidMount() {}

	componentDidUpdate(prevProps: Props) {}

	handleInputChange = e => {
		const info = { ...this.state.form, [e.target.name]: e.target.value };
		const errors = {};
		const { error } = e.currentTarget.dataset;

		if (this.state.emailSent) {
			this.setState({ emailSent: false });
		}

		if (e.target.value.length < 1) {
			errors[error] = 'שדה חובה';
			const errorsInfo = { ...this.state.errors, ...errors };
			this.setState({
				form: info,
				errors: errorsInfo,
			});
		} else {
			errors[error] = '';
			const errorsInfo = { ...this.state.errors, ...errors };
			this.setState({
				form: info,
				errors: errorsInfo,
			});
		}
	};

	handleCheckboxChange = e => {
		const info = { ...this.state.form, [e.target.name]: e.target.checked };
		const errors = {};
		if (!e.target.checked) {
			const errorsInfo = { ...this.state.errors, ...errors };
			this.setState({
				form: info,
				errors: errorsInfo,
			});
		} else {
			errors['checkboxError'] = '';
			const errorsInfo = { ...this.state.errors, ...errors };
			this.setState({
				form: info,
				errors: errorsInfo,
			});
		}
	};

	onSubmitEmail = async e => {
		e.preventDefault();
		const { checklistInfo } = this.props;

		const { form } = this.state;
		const emailRegExp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		const validEmail = emailRegExp.test(form.generalEmail.toLocaleLowerCase());
		const errors = {};
		const isShowCheckbox = _.get(checklistInfo, 'form.enableChecboxForMailBox', false);

		if (!form.generalEmail) {
			errors.emailError = 'שדה חובה';
		}

		if (form.generalEmail && !validEmail) {
			errors.emailError = 'יש למלא כתובת מייל תקינה';
		}

		if (!form.checkbox && isShowCheckbox) {
			errors.checkboxError = 'שדה חובה';
		}

		if (_.isEmpty(errors)) {
			const isFiveItemsInEmail = _.get(checklistInfo, 'form.isFiveItemsInEmail', false);
			const newEmailsArray = [];
			const shuffleNotSelectedItems = _.shuffle(this.props.emailData.notSelectedIds);
			const sentEmailInfoData = { ...this.props.emailData, usersEmail: form.generalEmail };

			try {
				if (isFiveItemsInEmail) {
					for (let i = 0; i <= 4; i++) {
						if (shuffleNotSelectedItems[i]) {
							newEmailsArray.push(shuffleNotSelectedItems[i]);
						}
					}

					_.set(sentEmailInfoData, 'notSelectedIds', newEmailsArray);
				}

				const [sentEmailInfoResult, addVotedEmailInfoResult] = await Promise.all([
					this.props.sentEmailInfo({
						collection: COLLECTIONS.GALLERYITEMS,
						data: sentEmailInfoData,
					}),
					this.props.addVotedEmailInfo({
						collection: COLLECTIONS.EMAILSDATA,
						data: { email: form.generalEmail, checklistId: checklistInfo.id },
					}),
				]);

				if (sentEmailInfoResult?.result === 'ok' && addVotedEmailInfoResult) {
					// ga.onSendEmailClick();

					this.setState({ emailSent: true });
				}
				this.setState({
					form: { generalEmail: '', checkbox: false },
					errors: { emailError: '', checkboxError: '' },
				});
			} catch (err) {
				console.info('error while sentEmailInfo and addVotedEmailInfo', err.message || err);
			}
		} else {
			const errorsInfo = { ...this.state.errors, ...errors };
			console.info('errorsInfo', errorsInfo);
			this.setState({
				errors: errorsInfo,
			});
		}
	};

	render() {
		const { checklistInfo } = this.props;
		const { form, errors, emailSent } = this.state;
		const { generalEmail, checkbox } = form;
		const title = _.get(checklistInfo, 'form.mailBoxTitle', '');
		const titleColor = _.get(checklistInfo, 'form.mailBoxTitleColor', '#fff');
		const btnColor = _.get(checklistInfo, 'graphics.buttonsTextColor', '#fff');
		const btnBg = _.get(checklistInfo, 'graphics.buttonsBackgroundColor', '#000');
		const successColor = _.get(checklistInfo, 'form.resultsTextsColor', '#000');
		const { emailError, checkboxError } = errors;
		const embedCode = decodeURIComponent(_.get(checklistInfo, 'general.pixelRegistration', ''));
		const successText = 'תודה, הרשימה בדרך למייל שלך!';
		const isShowCheckbox = _.get(checklistInfo, 'form.enableChecboxForMailBox', false);
		const checkboxText = _.get(checklistInfo, 'form.checkboxForEmailBoxText', '');
		console.info('checkboxError', checkboxError);
		return (
			<div className={css.emailForm}>
				{emailSent ? (
					<p className={css.successText} style={{ color: successColor }}>
						{successText}
					</p>
				) : (
					<>
						<h3 className={css.formTitle} style={{ color: titleColor }}>
							{title}
						</h3>
						<div className={css.formWrapper}>
							<div className={css.formRow}>
								<input
									type="text"
									name="generalEmail"
									id="generalEmail"
									placeholder="example@mail.co.il"
									onChange={this.handleInputChange}
									value={generalEmail}
								/>
								{emailError && <p className={css.error}>{emailError}</p>}
							</div>
							{isShowCheckbox && (
								<div className={css.formRow}>
									<label className={classNames(css.checkboxRow, checkbox && css.active)}>
										<input
											type="checkbox"
											id="checkbox"
											name="checkbox"
											value={checkbox}
											onChange={this.handleCheckboxChange}
										/>
										<div className={css.controll}></div>
										<p style={{ color: titleColor }}>{checkboxText}</p>
									</label>
									{checkboxError && <p className={css.error}>{checkboxError}</p>}
								</div>
							)}
						</div>
						<div className={css.emailFormSubmitWrapper}>
							<a
								href="#"
								style={{ color: btnColor, backgroundColor: btnBg }}
								onClick={this.onSubmitEmail}
							>
								שלחו אליי
							</a>
						</div>
					</>
				)}
				{this.state.emailSent && <Embed code={embedCode} />}
			</div>
		);
	}
}

const mapState = (state: ClientStore) => ({});
const mapDispatch = {
	sentEmailInfo,
	addVotedEmailInfo,
};

export default connect(mapState, mapDispatch)(EmailForm);
